import React, { FC } from "react";
import clsx from "clsx";
import { Theme } from "@material-ui/core/styles";
import { makeStyles, Typography } from "@material-ui/core";
import WeduTooltip from "../WeduTooltip/intex";
import { ApplicationStatus } from "../../modules/application/types";

const useStyles = makeStyles((theme: Theme) => ({
  mainContainer: {
    display: "flex",
    alignItems: "center",
  },
  label: {
    fontSize: 14,
    color: "#231F20",
    marginLeft: 5,
  },
  dot: {
    width: 14,
    height: 14,
    borderRadius: "50%",
  },
  colorApproved: {
    backgroundColor: theme.palette.success.main,
  },
  colorPending: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

interface ApplicationsCountProps {
  color: ApplicationStatus;
  label?: string;
  tooltip?: string;
}

const LabeledDot: FC<ApplicationsCountProps> = ({ color, label, tooltip }) => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      <WeduTooltip title={tooltip}>
        <div
          className={clsx(
            classes.dot,
            color === ApplicationStatus.PENDING && classes.colorPending,
            color === ApplicationStatus.APPROVED && classes.colorApproved,
          )}
        ></div>
      </WeduTooltip>
      {!!label && <Typography className={classes.label}>{label}</Typography>}
    </div>
  );
};

export default LabeledDot;
